import { ProductLine } from "src/api/client-api/productLines/useProductLines";
import { ProductLineWrite } from "src/api/client-api/productLines/useCreateProductLine";
import { z } from "zod";

export class ProductLineFormService {
    static getProductLineToForm = (existingProductLine?: ProductLine): ProductLineGridForm => {
        if (!existingProductLine) return { name: "" };

        return {
            id: existingProductLine.id,
            name: existingProductLine.name,
            parent: existingProductLine.parent?.["@id"] ?? null,
        };
    };

    static getFormToProductLineWrite = (form: ProductLineGridForm): ProductLineWrite => {
        const productLineWrite: ProductLineWrite = {
            name: form.name,
            parent: form.parent && form.parent !== "" ? form.parent : null,
        };

        if (form.id !== undefined) {
            productLineWrite.id = form.id;
        }

        return productLineWrite;
    };
}

export type ProductLineGridForm = {
    id?: number;
    name: string;
    parent?: string | null; // IRI string
};

export const ProductLineGridFormZodSchema: z.ZodSchema<ProductLineGridForm> = z.object({
    id: z.number().optional(),
    name: z.string().min(1, "Le nom est requis"),
    parent: z.string().nullable().optional(),
});
